import React from 'react';
import { useMassActionState } from 'src/components/massAction/MassActionStateContext';
import EmailObjectLabel from 'src/components/common/contentEditor/EmailObjectLabel';

const MassActionEmailObjectLabel = ({ title }) => {
  const [{ contentValidity }] = useMassActionState();
  return <EmailObjectLabel contentValidity={contentValidity} title={title} />;
};

export default MassActionEmailObjectLabel;
